<template>
  <div class="gg-account">
    <a-row type="flex" class="account-title">
      <a-col flex="auto">
        <span class="account-name">【MCC账户管理】-{{nowRow.name}}</span>
        <a-button class="syn-mcc-btn" @click="synClick" :disabled="synLoading"><icon-font type="icon-Reload" :class="synLoading?'active':''"/>同步MCC</a-button>
        <span class="account-time">上次更新时间：{{synTime}}</span>
        <a-button type="link" class="syn-log-btn">同步日志</a-button>
        <a-tooltip class="syn-help">
          <template slot="title">
            <span style="font-size: 12px">系统每小时同步一次数据，点击【同步日志】按钮可以查看你的MCC账号同步信息</span>
          </template>
          <icon-font type="icon-Question-Circle-Fill"/>
        </a-tooltip>
      </a-col>
      <a-col flex="270px">
        <a-input-search class="input-search" placeholder="请输入广告帐户名称或者ID" @search="search" />
      </a-col>
    </a-row>
    <a-table
      :columns="columns"
      :row-key="(record, index) => index"
      :data-source="mccList"
      :pagination="pagination"
      size="small"
      :loading="loading"
      @change="handleTableChange"
      class="account-table"
    >
    </a-table>
  </div>
</template>
<script>
import { getGoogleMcc, ggAccountOfMcc, synGoogleMccTime, synGoogleMcc } from "@/api/mediadata"

const columns = [
	{
		title: '账号ID',
		dataIndex: 'ggUserId',
		width: 200,
		align: 'center',
	},
	{
		title: '账号名称',
		dataIndex: 'descriptiveName',
		align: 'center',
		width: 200,
	},
  	{
		title: '账户类型',
		dataIndex: 'manager',
		align: 'center',
		width: 200,
	},
	{
		title: '币种',
		dataIndex: 'currencyCode',
		align: 'center',
		width: 80,
	},
	{
		title: '时区',
		dataIndex: 'timeZoneOffset',
		align: 'center',
		width: 100,
	},
  {
		title: '同步时间',
		dataIndex: 'updateTime',
		align: 'center',
		width: 150,
	}
]
export default {
	name: 'MediaData',
	data() {
		return {
			loading: false,
			pagination: {
				current: 1,
				total: 0,
				pageSize: 10
			},
      mccList: [],
      bmSelets: null,
			columns,
      synLoading: false,
      synTime: '',
		}
	},
  props: ['nowRow'],
  methods: {
    init() {
      this.getMccList()
    },
    // 同步账号
    synClick() {
      this.synLoading = true
      synGoogleMcc({
        userId: this.nowRow.userId,
      }).then((res) => {
        this.$message.success('同步成功！')
        this.getMccList()
        this.getSynTime()
      }).finally(() => this.synLoading = false)
    },
    getSynTime() {
      synGoogleMccTime({
        userId: this.nowRow.userId,
      }).then((res) => {
        this.synTime = res.data
      })
    },
    bmChange(e) {
      this.getList()
    },
    getMccList(searchKeyWord) {
      getGoogleMcc({
        pageSize: this.pagination.pageSize,
        pageNo: this.pagination.current,
        userId: this.nowRow.userId,
        searchKeyWord
      }).then((res) => {
        this.mccList = res.data.recordList || []
        this.pagination.total = res.data.recordCount
        console.log(this.mccList)
      })
    },
    search(value) {
      this.pagination.current = 1
      this.getList(value)
    },
    getList(searchKeyWord) {
      this.loading = true
      ggAccountOfMcc({
        pageSize: this.pagination.pageSize,
        pageNo: this.pagination.current,
        bmOrMcc: this.bmSelets,
        userId: this.nowRow.userId,
        searchKeyWord
      }).then((res) => {
        this.data = res.data.recordList || []
        this.pagination.total = res.data.recordCount
      }).finally(() => this.loading = false)
    },
    handleTableChange(pagination, filters, sorter) {
			console.log(pagination);
			const pager = { ...this.pagination };
			pager.current = pagination.current;
			this.pagination = pager;
			this.getMccList()
		},
  },
  mounted() {
  }
}
</script>
<style lang="less" scoped>
.fb-account {
  .account-title {
    margin-bottom: 16px;
  }
  .syn-mcc-btn {
    margin-bottom: 7px;
  }
  .bm-item {
    padding: 2px 16px;
    width: 270px;
    box-sizing: border-box;
  }
  .bm-name {
    color: #2D3446;
    font-size: 14px;
    line-height: 22px;
  }
  .bm-info {
    line-height: 20px;
    font-size: 12px;
    color: #677392;
  }
  .account-table-box {
    overflow: hidden;
  }
  .account-table {
    width: 100%;
  }
}
</style>